import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import CompanyUser from "./CompanyUser";
import GridConfig from "../GridConfig";

export default class CompanyUsers extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            companyId: props.CompanyId,
            controllerName: 'company/user',
            data: null,
            loading: true,
            configName: 'companyusers_grid',
            moduleName: 'کاربران کسب و کار'
        };
        this.state.filters = {
            companyId: this.state.companyId
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <CompanyUser Caller={this} Id={id} CompanyId={this.state.companyId} />
        });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <CompanyUser Caller={this} CompanyId={this.state.companyId} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "name", caption: "نام کاربر", show: true },
                { field: "mobile", caption: "شماره موبایل", show: true },
                { field: "relationString", caption: "نقش", show: true },
                { field: "createDatePersian", caption: "تاریخ ثبت", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'name' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 3 });
            if (f.field == 'mobile' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'relationString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDatePersian' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', filter: false, headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a className="hand text-danger" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em><span>حذف</span></a>
                ]
            }
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">دسترسی های شرکت</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, {
                                    add: true, print: false, pdf: false, excell: false, remove: false, config: false,
                                    otherFilters: null
                                })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}